import { render } from "./FlightSkeletonItem.vue?vue&type=template&id=314648e0"
import script from "./FlightSkeletonItem.vue?vue&type=script&lang=js"
export * from "./FlightSkeletonItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__